import { FC } from "react";

import { EmailLetterFilled } from "@livechat/design-system-icons";
import { Icon } from "@livechat/design-system-react-components";

import { AccordionItem } from "components/accordion-item/AccordionItem";
import { IProviderItemProps } from "interfaces/providerItem";

import { ForwardingAddressCopy } from "./ForwardingAddressCopy";
import { LiWithMargin, StepsList } from "./styles";

export const OtherEmailProvider: FC<IProviderItemProps> = ({
  opened,
  inboxAddress,
  onHeaderClick,
  handleMailboxCopying,
}) => (
  <AccordionItem
    opened={opened}
    onHeaderClick={onHeaderClick}
    title="Other providers"
    icon={<Icon size="large" source={EmailLetterFilled} />}
    className="provider-accordion-item"
  >
    <StepsList>
      <LiWithMargin>Open your email client.</LiWithMargin>
      <LiWithMargin>Find the forwarding settings.</LiWithMargin>
      <LiWithMargin>
        Select the <b>Forwarding</b> option and paste the HelpDesk forwarding address.
        <ForwardingAddressCopy inboxAddress={inboxAddress} handleMailboxCopying={handleMailboxCopying} />
      </LiWithMargin>
      <LiWithMargin>Follow the instructions.</LiWithMargin>
      <LiWithMargin>
        Optional: <b>Send a test message</b> to your own inbox, or wait for the first email from a customer.
      </LiWithMargin>
    </StepsList>
  </AccordionItem>
);
